module.exports = __webpack_public_path__ + "img/blog3.a4ee46b8.jpg";